import { Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, Button, useDisclosure, Input } from "@nextui-org/react";
import { useContext, useState } from "react";
import VerifyModal from "./VerifyModal";
import useAxios from '../../hooks/useAxios';
import { Authorization } from "../../providers/AuthContextProvider";

export default function EditModal({ titleFa, titleEn, type, verify, value }) {
    const { AxiosPrivate } = useAxios()
    const { isOpen, onOpen, onOpenChange } = useDisclosure();
    const [state, setState] = useState(value)
    const { setReload } = useContext(Authorization)

    const handleSubmit = async () => {
        await AxiosPrivate.put('user/update', { [titleEn]: state })
            .then(res => {
                setReload(Math.random())
                alert(res.data.message || 'با موفقیت ویرایش شد')
                onOpenChange(false)
            })
            .catch(err => alert(err.response?.data.message || 'ویرایش نشد'))
    }

    return (
        <>
            <div onClick={onOpen} className='cursor-pointer centerOfPareent'>
            <svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg>
            </div>
            <Modal isOpen={isOpen} onOpenChange={onOpenChange} isDismissable={false} isKeyboardDismissDisabled={true} dir="rtl">
                <ModalContent>
                    {(onClose) => (
                        <>
                            <ModalHeader className="flex flex-col gap-1">ویرایش {titleFa}</ModalHeader>
                            <ModalBody>
                                <Input
                                    dir="auto"
                                    label={titleFa}
                                    value={state}
                                    type={type}
                                    onValueChange={setState}
                                />
                            </ModalBody>
                            <ModalFooter>
                                <Button color="danger" variant="light" onPress={onClose}>
                                    بستن
                                </Button>
                                {verify ? <VerifyModal state={state} titleEn={titleEn} onOpenParentChange={onOpenChange} /> :
                                    <Button color="primary" onClick={handleSubmit}>
                                        ویرایش
                                    </Button>}
                            </ModalFooter>
                        </>
                    )}
                </ModalContent>
            </Modal>
        </>
    );
}
